import { AxiosError } from 'axios';
import { toast } from 'react-toastify';
import { logUserOut } from './logUserOut';
import customToast, { ToastType } from '../components_/Toast';

const showErrorToastMessage = (errmsg: string) => {
  customToast(errmsg, ToastType.error);
};

type TArgs = {
  error: AxiosError<{ message?: string; status?: number }>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  errorFn: any;
};
export const handleError = ({ error, errorFn }: TArgs) => {
  if (error?.response?.data?.status === 593) {
    logUserOut(error?.response?.data?.status);
  }
  if (error?.message?.split(' ')?.includes('timeout')) {
    showErrorToastMessage('Request timed out, please retry.');
  } else {
    errorFn(error);
  }
};
